import { backgroundColor, blackColors, whiteColor, defaultBoxShadow } from 'assets/jss/material-dashboard-pro-react';

const servicesStyles = (theme) => ({
	cardBody: {
		padding: 0,
		'& > div': {
			margin: 0,
		},
	},
	card: {
		borderRadius: 0,
	},
	switch: {
		flexDirection: 'row-reverse',
		margin: 0,
		'& .MuiSwitch-root': {
			marginRight: '-12px',
		},
	},
	header: {
		textAlign: 'right',
	},
	noServices: {
		padding: '20px 10px',
		backgroundColor: backgroundColor[0],
		textAlign: 'center',
	},
	postpaidWrapper: {
		backgroundColor: backgroundColor[0],
		'& > div': {
			marginTop: 0,
			'&:first-of-type': {
				marginBottom: '8px',
			},
			'&:last-of-type': {
				marginBottom: 0,
			},
		},
	},
	creditLimitCard: {
		'& > div': {
			// card body
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			'& > div': {
				display: 'flex',
				flexDirection: 'column',
				'& p': {
					marginBottom: 0,
				},
			},
		},
	},
	numberInfo: {
		padding: '20px 0 28px 0',
	},
	creditLimitCurrency: {
		fontSize: theme.fontSize(14),
		fontFamily: theme.fontFamily.alvar.regular,
	},
	confirmationDialogServiceName: {
		paddingBottom: '35px',
	},
	confirmationDialogFooter: {
		paddingTop: '8px',
		borderTop: `1px solid ${blackColors[6]}`,
	},
	confirmationDialogLoader: {
		height: '228px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	activateShortcodeWrapper: {
		maxWidth: '400px',
		margin: '0 auto',
	},
	activateShortcodeInputWrapper: {
		maxWidth: '150px',
		margin: '0 auto',
	},
	cpnActivationDialogBodyWrapper: {
		margin: '32px auto 48px',
	},
	cpnActivationDialogBody: {
		width: 400,
		maxWidth: '90%',
		margin: '0 auto',
	},
	staticIPActivationDialogBodyWrapper: {
		margin: '32px auto 48px',
	},
	staticIPActivationDialogHeader: {
		width: 400,
		maxWidth: '90%',
		margin: '0 auto',
	},
	staticIPActivationDialogCheckboxWrapper: {
		width: 400,
		maxWidth: '85%',
		margin: '0 auto',
		display: 'flex',
		flexDirection: 'column',
	},
	staticIPActivationDialogBody: {
		width: 400,
		maxWidth: '85%',
		margin: '0 auto',
	},
	failureDialogBody: {
		marginBottom: 60,
	},
	successDialogBody: {
		'& > div': {
			margin: '32px auto 30px',
			paddingTop: 11,
			width: 200,
			textAlign: 'center',
			borderTop: `solid 1px ${blackColors[6]}`,
		},
	},
	deactivationDialogBody: {
		marginBottom: 60,
	},
	gobizDialogBodyWrapper: {
		padding: '24px 52px 0',
	},
	internationalMinutesBodyWrapper: {
		padding: '32px 80px',
		[theme.breakpoints.down('sm')]: {
			padding: '32px 25px',
		},
	},
	internationalMinutesTooltip: {
		backgroundColor: whiteColor,
		color: blackColors[1],
		...defaultBoxShadow,
		maxWidth: 494,
		width: 494,
		[theme.breakpoints.down('sm')]: {
			maxWidth: '95vw',
		},
		'& > span': {
			// arrow
			color: whiteColor,
		},
	},
	termsAndConditionsWrapper: {
		padding: '0 120px',
		[theme.breakpoints.down('sm')]: {
			padding: '0 40px',
		},
	},
	jawazakBodyWrapper: {
		padding: '0 80px',
		[theme.breakpoints.down('sm')]: {
			padding: '0 40px',
		},
	},
	jawazakDialogBodyWrapper: {
		padding: '24px 0 34px',
	},
	termsAndConditionsLink: {
		paddingTop: '10px',
	},
	acceptTermsAndConditions: {
		margin: '0 -10px',
	},
	termsAndConditionsErrorBoxWrapper: {
		marginTop: '5px',
		'& > div': {
			maxWidth: 256,
			margin: '0 auto',
		},
	},
	relative: {
		position: 'relative',
	},
	countriesFog: {
		width: '100%',
		height: 43,
		position: 'absolute',
		bottom: 0,
		background: 'linear-gradient(to top, #FFF 36%, rgba(255, 255, 255, 0))',
	},
	countries: {
		maxHeight: 520,
		paddingBottom: 43,
		display: 'flex',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
		'& > div': {
			width: 120,
			[theme.breakpoints.down('sm')]: {
				width: 100,
			},
		},
		[theme.breakpoints.down('sm')]: {
			maxHeight: 600,
		},
	},
	countriesWrapper: {
		height: 114,
		overflow: 'auto',
		marginBottom: 24,
		marginTop: 15,
	},
});

export default servicesStyles;
